import {
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Input,
  Row,
  Typography,
} from "antd";
import moment from "moment-timezone";
import { BranchSelector } from "shared/components/branch/branch-selector";
import {
  PromotionConditionModel,
  PromotionConst,
} from "shared/models/promotion.model";
import { momentDateTimeFormat } from "shared/plugins/localization";
import { BranchModel } from "states/branch/branch.models";
import {
  LogicalTermEnum,
  ProductCategoryModel,
} from "states/product-category/product-category.models";
import { PromotionCodeModel } from "states/promotion-code/promotion-code.models";

import { PromotionProductTransferComponent } from "./promotion-products-transfer-component";

export interface IPromotionCodeConditionTabProps {
  model: PromotionCodeModel;
  onChange: (newModel: PromotionCodeModel) => void;
  categories: ProductCategoryModel[];
  isUpdateMode: boolean;
  currentTimeZone: string;
}
export function PromotionCodeConditionTab(
  props: IPromotionCodeConditionTabProps
) {
  const { model, categories, onChange, isUpdateMode, currentTimeZone } = props;
  const getModelTemp = () => {
    return { ...model };
  };
  const handleChange = (targetKeys: number[]) => {
    let model = getModelTemp();
    if (
      getIndexCondition(
        PromotionConst.promotionConditionType.buyAtLeastXProductInListProduct
      ) === -1
    ) {
      model.promotion.conditions.push({
        type: PromotionConst.promotionConditionType
          .buyAtLeastXProductInListProduct,
        logicType: LogicalTermEnum.And,
        numberOfProduct: 1,
        productIds: [],
      } as PromotionConditionModel);
    }
    model.promotion.conditions[
      getIndexCondition(
        PromotionConst.promotionConditionType.buyAtLeastXProductInListProduct
      )
    ].productIds = targetKeys;
    onChange(model);
  };
  const getIndexCondition = (type: string) => {
    return getModelTemp()?.promotion?.conditions?.findIndex(
      (m) => m.type === type
    );
  };
  const getCondition = (type: string) => {
    let conditionIndex = getIndexCondition(type);
    return getModelTemp()?.promotion?.conditions?.[conditionIndex];
  };
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span="8">
          <Collapse defaultActiveKey={["1"]} className="mb-4">
            <Collapse.Panel key="1" header="Ngày áp dụng">
              <Input.Group className="mb-4">
                <Typography.Text>Từ ngày: </Typography.Text>
                <DatePicker
                  showTime
                  value={moment(
                    getCondition(
                      PromotionConst.promotionConditionType.startDate
                    )?.dateAndTime
                  ).tz(currentTimeZone)}
                  format={momentDateTimeFormat()}
                  onChange={(value, valStr) => {
                    let model = getModelTemp();
                    if (
                      getIndexCondition(
                        PromotionConst.promotionConditionType.startDate
                      ) === -1
                    ) {
                      model.promotion.conditions.push({
                        type: PromotionConst.promotionConditionType.startDate,
                        logicType: LogicalTermEnum.And,
                        dateAndTime: new Date(),
                      } as PromotionConditionModel);
                    }
                    model.promotion.conditions[
                      getIndexCondition(
                        PromotionConst.promotionConditionType.startDate
                      )
                    ].dateAndTime = moment
                      .tz(valStr, momentDateTimeFormat(), currentTimeZone)
                      .toDate();
                    onChange(model);
                  }}
                  className="w-100"
                />
              </Input.Group>
              <Input.Group>
                <Typography.Text>Đến ngày: </Typography.Text>
                <DatePicker
                  showTime
                  value={moment(
                    getCondition(PromotionConst.promotionConditionType.endDate)
                      ?.dateAndTime
                  ).tz(currentTimeZone)}
                  format={momentDateTimeFormat()}
                  onChange={(value, valStr) => {
                    let model = getModelTemp();
                    if (
                      getIndexCondition(
                        PromotionConst.promotionConditionType.endDate
                      ) === -1
                    ) {
                      model.promotion.conditions.push({
                        type: PromotionConst.promotionConditionType.endDate,
                        logicType: LogicalTermEnum.And,
                        dateAndTime: new Date(),
                      } as PromotionConditionModel);
                    }
                    model.promotion.conditions[
                      getIndexCondition(
                        PromotionConst.promotionConditionType.endDate
                      )
                    ].dateAndTime = moment
                      .tz(valStr, momentDateTimeFormat(), currentTimeZone)
                      .toDate();
                    onChange(model);
                  }}
                  className="w-100"
                />
              </Input.Group>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Collapse defaultActiveKey={["1"]}>
            <Collapse.Panel
              key="1"
              header="Mua số lượng X sản phẩm trong danh sách"
            >
              <Input.Group className="mb-4">
                <Typography.Text>Số lượng mua tối thiểu: </Typography.Text>
                <Input
                  value={
                    getCondition(
                      PromotionConst.promotionConditionType
                        .buyAtLeastXProductInListProduct
                    )?.numberOfProduct
                  }
                  onChange={(e) => {
                    let model = getModelTemp();
                    if (
                      getIndexCondition(
                        PromotionConst.promotionConditionType
                          .buyAtLeastXProductInListProduct
                      ) === -1
                    ) {
                      model.promotion.conditions.push({
                        type: PromotionConst.promotionConditionType
                          .buyAtLeastXProductInListProduct,
                        logicType: LogicalTermEnum.And,
                        numberOfProduct: 1,
                        productIds: [],
                      } as PromotionConditionModel);
                    }
                    model.promotion.conditions[
                      getIndexCondition(
                        PromotionConst.promotionConditionType
                          .buyAtLeastXProductInListProduct
                      )
                    ].numberOfProduct = Number(e.target.value);
                    onChange(model);
                  }}
                  placeholder="Số lượng mua tối thiểu"
                ></Input>
              </Input.Group>
              <PromotionProductTransferComponent
                productIds={
                  getCondition(
                    PromotionConst.promotionConditionType
                      .buyAtLeastXProductInListProduct
                  )?.productIds ?? []
                }
                onChange={(productIds: number[]) => {
                  handleChange(productIds);
                }}
                currentTimeZone={currentTimeZone}
                categories={categories}
              />
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
    </div>
  );
}
